import React from 'react';
import { Modal } from '@/components';
import { Message } from '@/entities';
import { ReadMessageFlow } from './read-message-flow';

interface ReadMessageModalProps {
  message: Message | null;
  isOpen: boolean;
  onClose: () => void;
}

export const ReadMessageModal: React.FC<ReadMessageModalProps> = ({ message, isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ReadMessageFlow message={message} onClose={onClose} />
    </Modal>
  );
};
